import client from '@/services/';

const state = () => ({
    uploadedFile: null,
    uploadedFichier: null,
    all: [],
    allSociete: [],
});

const getters = {
    uploadedFile: state => state.uploadedFile,
    uploadedFichier: state => state.uploadedFichier,
    all: state => state.all,
    allSociete: state => state.allSociete,
};

const mutations = {
    SET_UPLOADED_FILE: (state, form) => {
        state.uploadedFile = form;
    },
    SET_UPLOADED_FICHIER: (state, form) => {
        state.uploadedFichier = form;
    },
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ALL_SOCIETE: (state, obj) => {
        state.allSociete = obj;
    },
};

const actions = {
    async uploadFichier({ commit }, { idSousCategorie, fileData }) {
        const { data } = await client.post(
            `/importation/utilisateurs/${idSousCategorie}`,
            fileData, 
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        commit('SET_UPLOADED_FILE', data);
        return data;
    },
    async getAll({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', email = '', matriculeAncien = '', matricule = '', libelle = '', nom = '', prenoms = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            email,
            matriculeAncien,
            matricule,
            libelle,
            nom,
            prenoms
            
        }).toString();
        let data = await client.get(`/importation?${queryParams}`);
        commit("SET_ALL", data.data);
        return data.data;
    },
    async uploadFichierSociete({ commit }, { idSousCategorie, fileData }) {
        const { data } = await client.post(
            `/importation-societe/upload/${idSousCategorie}`,
            fileData, 
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        commit('SET_UPLOADED_FILE', data);
        return data;
    },
    async getAllSociete({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', raisonSociale = '', nomDirigeant = '', prenomDirigeant = '', matriculeDirigeant = '', anneeInscription = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            raisonSociale,
            nomDirigeant,
            prenomDirigeant,
            matriculeDirigeant,
            anneeInscription,
            
            
        }).toString();
        let data = await client.get(`/importation-societe?${queryParams}`);
        commit("SET_ALL_SOCIETE", data.data);
        return data.data;
    },
    async receiveNotification(_, payload) {
        try {
            
            await client.post('/importation/create/demande/notify', payload);
        } catch (error) {
            console.error('Erreur dans receiveNotification Vuex :', error);
            throw error;
        }
    },
    async receiveNotificationSociete(_, payload) {
        try {
            const { data } = await client.post('/importation-societe/create/demandeSociete/notify', payload);
            return data;
        } catch (error) {
            console.error('Erreur dans receiveNotificationSociete Vuex :', error);
            throw error;
        }
    },
    async statistiqueImportation() {
        let data = await client.get('/importation/statistiques');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async statistiqueImportationSociete() {
        let data = await client.get('/importation-societe/statistiques');
        return data;
    },
    async resendEmail(_, payload) {
        try {
            await client.post('/importation/mail/demande', payload);
        } catch (error) {
            console.error('Erreur dans receiveNotificationSociete Vuex :', error);
            throw error;
        }
    },
    

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};